// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/type-cars/list',
    name: 'type-cars-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/Type.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_type_auto_cars',
    },
  },
  {
    path: '/type-cars/update',
    name: 'type-cars-update',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/cars/form/TypeCarroseria.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_type_auto_cars',
    },
  },
]

export default formTable
